import axios, { type AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import authService from 'src/services/authService';
import { addError, refreshPage } from 'src/store/errorBoundarySlice';
import { setIsAUSTINDown } from 'src/store/newJmrPageSlice/newJmrPageSlice';

import store from '../store/store';

const apiClient = axios.create({
  baseURL: 'https://beta.na.rtw-api.whs.amazon.dev',
});

axiosRetry(apiClient, {
  retries: 1, // number of retries
  retryDelay: (retryCount: number) => {
    console.info(`retry attempt: ${retryCount}`);
    // use store.dispatch(getUser()) will make retry instantly, which cause more chance to having race condition
    authService.login();
    return retryCount * 2000; // time interval between retries
  },
  retryCondition: (error: AxiosError) => {
    // if retry condition is not specified, by default idempotent requests are retried

    console.error(JSON.stringify(error));
    const status = error.response?.status;
    if (!status || status != 401) {
      return false;
    }
    return true;
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 403) {
      store.dispatch(refreshPage());
    } else if (error.response?.status !== 429) {
      // If the response is from the incident API swallow the error let the,
      // React component handle the error messaging
      if (isErrorFromIncidentAPI(error)) {
        store.dispatch(setIsAUSTINDown(true));
        return;
      } else {
        store.dispatch(setIsAUSTINDown(false));
      }
      // if the response is from query AUSTIN case id,
      // swallow the error let React component handle the redirect
      if (isErrorFromGetAccommodationIdByCaseIdAndLoginApi(error)) {
        return error.response?.data;
      } else if (error.response?.data?.message) {
        const data = error.response.data;
        // give a more descriptive and less confusing toast than "No message available" on 404s
        if (data.message === 'No message available' && data.error && data.path) {
          store.dispatch(addError(`${data.error} ${data.path}`));
        } else {
          store.dispatch(addError(data.message));
        }
      } else {
        store.dispatch(addError(error?.message));
      }
    }
  },
);

const isErrorFromGetAccommodationIdByCaseIdAndLoginApi = (error: AxiosError) => {
  return error.response?.status === 400 && error.response?.data?.path?.startsWith('/accommodation/type');
};

const isErrorFromIncidentAPI = (error: AxiosError) => {
  const { data, status } = error.request ?? {};
  const path = data?.path ?? '';
  return status === 500 && (path.startsWith('/incident/associate/') || path.startsWith('/incident/accommodation/'));
};

export default apiClient;
